export const getFormattedTime = date => {
    const sec = parseInt(date, 10) // convert value to number if it's string
    let hours = Math.floor(sec / 3600) // get hours
    let minutes = Math.floor((sec - hours * 3600) / 60) // get minutes
    let seconds = sec - hours * 3600 - minutes * 60 //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours < 10) {
        hours = '0' + hours
    }
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    if (seconds < 10) {
        seconds = '0' + seconds
    }
    return hours + 'h ' + minutes + 'm'
}
export function getIndianTime() {
    // Get user's timezone offset in minutes
    const userTimeZoneOffset = new Date().getTimezoneOffset();
    // IST offset in minutes (UTC+5:30)
    const indianTimeZoneOffset = -330;
    // Calculate the time difference
    const timeDifferenceMinutes = indianTimeZoneOffset - userTimeZoneOffset;
    // Get the current time
    const currentTime = new Date();
    // Calculate Indian time by adding the time difference
    const indianTime = new Date(currentTime.getTime() + timeDifferenceMinutes * 60 * 1000);
    return indianTime;
}
export function isWithinTimeRange(fromTime, toTime) {
    const startTime = new Date(fromTime);
    const endTime = new Date(toTime);
    const currentTime = getIndianTime();
    return currentTime >= startTime && currentTime <= endTime;
  }